import classifiers from './classifiers';
import classifiersTables from './classifiers-tables';
import classifierLevels from './classifier-levels';
import classes from './classes';
import features from './features';
import documents from './documents';
import sections from './sections';
import docClasses from './doc-classes';
import implementators from './implementators';
import requirements from './requirements';
import accordions from './accordions';
import reqClasses from './req-classes';
import reqFeatures from './req-features';

export default {
  classifiers,
  classifiersTables,
  classifierLevels,
  classes,
  features,
  documents,
  sections,
  docClasses,
  implementators,
  requirements,
  accordions,
  reqClasses,
  reqFeatures,
};
